import { useAppSelector } from '@hooks/app/redux';
import { getPrescriptionsRequests } from '@services/external/e-prescriptions.api';
import { useQuery, UseQueryOptions } from 'react-query';

async function handler(providerId: string) {
  const { data } = await getPrescriptionsRequests(providerId);

  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function usePrescriptionsPatients(
  options?: UseQueryOptions<TQueryData | null, unknown, TQueryData, any>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['prescriptions:prescriptions-patients', providerId],
    () => handler(providerId),
    options,
  );
}

export default usePrescriptionsPatients;
